import React from "react";
import dayjs from "dayjs";

import { s360ConfigService } from "../../Services/S360Config";
function MessageA15(props) {

  const messageBoxStyle = () => {
    return s360ConfigService.config?.customDesign?.messageA15Box;
  }

  const messageTimeStyle = () => {
    return s360ConfigService.config?.customDesign?.messageA15Time;
  }

  return (
    <div className="s360-message-cotainer-received">
      <div className="s360-message-box-custom-a15-received" style={messageBoxStyle()}>
        {props.entry.text || ''}
      </div>
      {props.isLastEntry && props.sentTimestamp && <div className="s360-message-time-received" style={messageTimeStyle()}>
        {dayjs.unix(props.sentTimestamp).format("DD MMM h:mm a")}
      </div>}
    </div>
  );
}

export default MessageA15;
